export default __webpack_public_path__ + "static/media/thailand.e1725bd4.jpg";